import Head from "next/head";
import styled from "@emotion/styled";
import { AppProps } from "next/app";
import { ReactElement } from "react";
import { Provider } from "react-redux";
import t from "../../../src/helper/t";
import { store } from "../../../src/store";
import LoggerViewSwitcher from "./LoggerViewSwitcher";
import { ThemeProvider } from "@emotion/react";
import { theme } from "../../theme/theme";
import Navbar from "../splus3/elements/Navbar";
import Footer from "../splus3/elements/Footer";
import ErrorDialogSwitcher from "../splus3/elements/ErrorDialogSwitcher";

const Container = styled.div(({ theme }) => ([
    theme.splus3.background.primary,
    {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",

        /* for mobile */
        [theme.splus3.breakpoints.mobile]: [
            theme.splus3.background.white,
            {
                minWidth: 320,
            }
        ],
    }
]));

const SPlus3ViewPage = ({ Component, pageProps }: AppProps): ReactElement => {
    return (
        <>
            <Head>
                <title>{t("Title")}</title>
                <meta name="description" content={t("Description")}></meta>
                <meta name="revisit-after" content="1 days"></meta>
                <meta name="referrer" content="no-referrer"></meta>
            </Head>
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Component {...pageProps} />
                </ThemeProvider>
            </Provider>
        </>
    );
}

export default SPlus3ViewPage;